var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('chat-header'),_vm._v(" "),_c('chat-contents',{attrs:{"form-count":_vm.formCount},on:{"form-countup":_vm.formCountup}}),_vm._v(" "),_c('chat-footer',{attrs:{"total":_vm.formCount.total,"answer":_vm.formCount.answer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1112c02c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatWrap.vue
// module id = null
// module chunks = 